import React from 'react';
import './Footer.css';
import schoolBadge from '../Photoset/schoolBadge.svg';
import { Link } from 'react-router-dom';

function Footer() {
    const value1 = localStorage.getItem("ปฏิทินการศึกษา");
    const value2 = localStorage.getItem("ตารางเรียน");
    const value3 = localStorage.getItem("ตารางสอน");
    const value4 = localStorage.getItem("รายชื่อนักเรียน");

    return (
        <footer>
            <div className='main-footer'>
                <h1>โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย <br />PHAYAKKHAPHUM PHISAI SUB DISTRICT MUNICIPALITY SCHOOL <br /> <img className='schoolBadge' src={schoolBadge} alt="schoolBadge" /></h1>
                <div className='aboutSchool'>
                    <h>เกี่ยวกับโรงเรียน</h>
                    <div className='main-3-footer'>
                        <Link to='/information/history'><aside>ประวัติโรงเรียน</aside></Link>
                        <Link to='/information/administrator'><aside>ผู้บริหาร</aside></Link>
                        <Link to='/contact'><aside>ติดต่อเรา</aside></Link>
                    </div>
                </div>
                <div className='forStudent'>
                    <h>สำหรับนักเรียน</h>
                    <div className='main-3-footer'>
                        <Link to={value1} target='_blank'><aside>ปฏิทินการศึกษา</aside></Link>
                        <Link to={value2} target='_blank'><aside>ตารางเรียน</aside></Link>
                    </div>
                </div>
                <div className='forTeacher'>
                    <h>สำหรับคณะครู</h>
                    <div className='main-3-footer'>
                        <Link to={value3} target='_blank'><aside>ตารางสอน</aside></Link>
                        <Link to={value4} target='_blank'><aside>รายชื่อนักเรียน</aside></Link>
                    </div>
                </div>
                {/* <div className='classcontact'> */}
                    <div className='classification'>
                        <h>กลุ่มสาระการเรียนรู้</h>
                        <div className='classification-1'>
                            <div className='main-4-footer'>
                                <div className='type1'>
                                    <Link to='/subject/social'><aside>สังคมศึกษา</aside></Link>
                                    <Link to='/subject/career'><aside>การงานอาชีพ</aside></Link>
                                    <Link to='/subject/art'><aside>ศิลปศึกษา</aside></Link>
                                    <Link to='/subject/thai'><aside>ภาษาไทย</aside></Link>
                                </div>
                                <div className='type2'>
                                    <Link to='/subject/english'><aside>ภาษาต่างประเทศ</aside></Link>
                                    <Link to='/subject/health'><aside>สุขศึกษาและพลศึกษา</aside></Link>
                                    <Link to='/subject/science'><aside>วิทยาศาสตร์</aside></Link>
                                    <Link to='/subject/math'><aside>คณิตศาสตร์</aside></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='contactUs'>
                        <h>ติดต่อเรา</h>
                        <div className='main-5-footer'>
                            <aside1>ที่อยู่ : 100 หมู่16 ตำบลลานสะแก อำเภอพยัคฆภูมิพิสัย จังหวัดมหาสารคาม 44110</aside1>
                            <aside1>อีเมล : Phayaksubmunicsch@gamil.com</aside1>
                            <aside1>เบอร์ติดต่อ : 043-790038 ต่อ 7121</aside1>
                        </div>
                    </div>
                {/* </div> */}
            </div>
            <div className='copyright-footer'>© 2023 Cadet UI. All Rights Reserved.</div>
        </footer>
    )
}

export default Footer